import React from 'react';

const PermEnLigne = ({ setCurrentform, currentform }) => {
  return (
    <div className='row mt-4'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>
              Inscription en ligne du bac Permanent
            </h2>
          </div>
          <div className='card-body'>
            <p>
              L'Inscription en ligne pour le bac Permanent contient Plusieurs
              étapes.
            </p>
            <p>
              vous devez vous munir de votre dernière Fiche de participation aux
              examens d'Etat
            </p>

            <p>
              vous aurez besoin de l'Annee Academique , du Numero d'Ordre ainsi
              que la Session qui se trouve dans la fiche
            </p>
            <p>Etes-vous Prêt ?</p>
          </div>

          <div className='card-footer'>
            <button
              className='btn btn-small btn-info mt-4'
              onClick={(e) => setCurrentform(currentform + 1)}
            >
              Oui
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermEnLigne;
